import {
    LEFTMENU_METHOD,
    NHANVIENS_METHOD,
    NPP_ROLE,
    ROLE_MENU_METHOD,
    INIT_ROLE_MENU,
    STATUS_METHOD,
    TINHTHANHS_METHOD,
    QUANHUYENS_METHOD,
    PHUONGXAS_METHOD,
    MAIN_METHOD
} from '@app/const/AppSetting';
import {getControllerName} from '@app/utils/helpers';
import axiosClient from './axios';
import {alertService} from "@app/services/alertService";
import {Redirect, Route} from "react-router-dom";
import { getAll as trangthaiSlice_getAll } from '@store/reducers/trangthaiSlice';
const  MY_METHOD = MAIN_METHOD;

export const getAllPhanquyen= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listphanquyen`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllColor= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listcolors`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllGuikem= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listguikem`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const showMenuRole = async () => {
    const v = await axiosClient.get(MY_METHOD+'menu_role/');
   // console.log(v);
    if(v && v.data && v.data.data)
        return v.data.data;
    else
        return null;
};


export const showLeftMenu = async () => {
    const v = await axiosClient.get(MY_METHOD+'menu_user/');
    console.log('menu: '+v);
    if(v && v.data && v.data.data)
        return v.data.data;
    else
        return null;
};

export const getAllTrangthai= async (dispatch) => {
    try {
        const res = await axiosClient.get(`${MY_METHOD}listtrangthai`);
        console.log('getAllTrangthai');
        console.log(res);
        dispatch(trangthaiSlice_getAll(res.data.data)); 
        return res.data.data;
    } catch (err) {
    }
};

export const getAllCountries
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listcountries`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllCity
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listcity`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllDistrict
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listdistrict`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllWards
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listwards`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllRanglienket
    = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listranglienket`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAutocompletesanpham
    = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}autocompletesanpham`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAutocompletedaohuu
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}timkiemdaohuu`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllNhaphanphoi= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listnhaphanphoi`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllKhachhang= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listkhachhang`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllNhanvien= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listnhanvien`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllDonvitinh= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listdonvitinh`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllLoaiphuchinh= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listloaiphuchinh`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllNhomnhanvien= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listnhomnhanvien`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllDonhang2= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listdonhang2`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllLoaidonhang= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listloaidonhang`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getLogStatusSO= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}getlogstatus`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getActivityLogs = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}getactivitylogs`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const resetPassword = async (param) => {
    return axiosClient.put(`changepassword`,param);
}

export const getNPPRole = async () => {
    const v = await axiosClient.get(NPP_ROLE);
    return v.data.data;
};

export const getTrangthai = async () => {
    const v = await axiosClient.get(STATUS_METHOD);
    return v.data.data;
};

export const getTinhthanh = async () => {
    const v = await axiosClient.get(TINHTHANHS_METHOD);
    /*console.log(
                'getAll tinhthanh= ',
                JSON.stringify(v.data.data, null, 2)
            );*/
    return v.data.data;
};

export const getQuanhuyen = async (id) => {
    if(id){
        const v = await axiosClient.get(`${QUANHUYENS_METHOD}?tinhthanhid=${id}`);
        return v.data.data;
    }
    else{
        const v = await axiosClient.get(`${QUANHUYENS_METHOD}`);
        return v.data.data;
    }
};

export const getPhuongxa = async (id) => {
    if(id)
    {
        const v = await axiosClient.get(`${PHUONGXAS_METHOD}?quanhuyenid=${id}`);
        return v.data.data;
    }
    else
    {
        const v = await axiosClient.get(`${PHUONGXAS_METHOD}`);
        return v.data.data;
    }
};

export const getSolanin = async (prefix, id) => {
    const v = await axiosClient.get(`solanin?loai=${prefix}&nghiepVuId=${id}`);
    return v.data.data;
};

export const postSolanin = async (prefix, id) => {
    const v = await axiosClient.post(`solanin?loai=${prefix}&nghiepVuId=${id}`);
    return v.data.data;
}

// eslint-disable-next-line camelcase,consistent-return
export const getRoleMENU = async (pathName) => {

    const controller = getControllerName(pathName);
    const res = await axiosClient .get(MY_METHOD + 'rolemenu/' + controller);
    //console.log('getRoleMENU');
    //console.log(res);
    if( res && res.data.status ==="1")
        return res.data.data;
    return INIT_ROLE_MENU
};

export const getRoleMENUApp = async (pathName) => {

    const controller = getControllerName(pathName);
    const res = await axiosClient .get(MY_METHOD + 'menuapp_role/' + controller);
    //console.log('getRoleMENU');
    //console.log(res);
    if( res && res.data.status ==="1")
        return res.data.data;
    return INIT_ROLE_MENU
};

export const checkRole = async (obj) => {
    const res = 
        getRoleMENU(obj.pathname)
        .then((role) => {
            if (obj.isAddMode && role.quyentaomoi !== 1) {
                obj.history.push(`/${obj.currController}`);
            }
            if (
                obj.pathname.indexOf(`edit`) > 0 &&
                !obj.isAddMode &&
                role.quyenchinhsua !== 1
            ) {
                obj.history.push(`/${obj.currController}`);
            }
            if (         
                role.quyenhienthi !== 1
            ) {
                obj.history.push(`/${obj.currController}`);
            }

            return role;
        })
        .catch((error) => {
            obj.history.push(`/${obj.currController}`);
        });
    return res;
};



export  const createObj =  async function (data, history,service, type,controller) {

    const result = await service.create(data);
    if (result.status) {
        alertService.success('Tạo mới thành công', {
            keepAfterRouteChange: true
        });
        //isAddMode = false;
        let id =result.data.id;
        //Nếu = 1 thì redirect tại trang edit, khác thì redirect đi đâu thì đi
        if(type === 1) {
            //let url = '/'+controller+'/edit/'+id;
            //console.log('url: '+url);
            //return <Redirect to='/SanPham/edit/1073' />;
            history.push('/'+controller+'/edit/'+id);
        }
        else {
            history.push('.');
        }
    } else {
        alertService.error(result.msg);
    }
}
export  const updateObj =  async function (idX,data, history,service, type, controller, msg) {
    const result = await service.update(idX, data);
    if (result.status) {
        alertService.success(msg, {
            keepAfterRouteChange: true
        });
        //Nếu = 1 thì redirect tại trang edit, khác thì redirect đi đâu thì đi
        if(type === 1) {
            history.push('/'+controller+'/edit/'+idX);
        }
        else {
            history.push('..');
        }

    } else {
        alertService.error(result.msg);
    }
}
